import { Input, message } from "antd";
import { UseApiCallV2, UseLazyApiCallV2 } from "hooks";
import { CasesTable } from "pages/cases-dashboard/components/cases-table-layout";
import { useCurrentUserContext } from "providers";
import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { SearchOutlined } from "@ant-design/icons";
import { useLanguageTranslator } from "hooks/use-language-translator";

export const CasesList = ({ message_id, refetchEmails }) => {
  const { user } = useCurrentUserContext();
  const [cases, setCases] = useState([]);
  const [userSearch, setUserSearch] = useState("");
  const { translator } = useLanguageTranslator();
  const casesTableTrans = translator("casesTable");
  const [
    addEmailToNote,
    {
      data: addEmailToNoteData,
      isLoading: addEmailToNoteLoading,
      error: addEmailToNoteErr,
    },
  ] = UseLazyApiCallV2({
    url: "/add_email_to_note",
    method: "POST",
  });
  const [
    removeEmailNoteFromCase,
    {
      data: removeEmailNoteFromCaseData,
      isLoading: removeEmailNoteFromCaseLoading,
      error: removeNoteFromErr,
    },
  ] = UseLazyApiCallV2({
    url: "/unassign_email",
    method: "POST",
  });

  const {
    data: casesData,
    isLoading,
    refetch: refetchCases,
  } = UseApiCallV2({
    url: "/get_cases_link",
    method: "POST",
    paramsData: {
      loggedUser: user?.email,
      message_id,
    },
  });
  useEffect(() => {
    getFilteredData(userSearch);
  }, [userSearch]);

  useEffect(() => {
    if (casesData?.items?.length > 0) {
      const sorted = casesData?.items?.sort((a, b) => {
        return (b.linked === true) - (a.linked === true);
      });
      setCases([...sorted]);
    }
  }, [casesData?.items]);

  async function handleAddEmailToNote({ case_id, linked, type }) {
    const params = {
      case_id,
      message_id,
      email: user?.email,
    };
    const addOrRemoveApi =
      type === "add" ? addEmailToNote : removeEmailNoteFromCase;

    try {
      const res = await addOrRemoveApi({
        params,
      });

      if (res?.status === "Success") {
        message.success(res?.message);
        refetchCases();
        refetchEmails();
      } else if (res?.statusCode === 200) {
        message.error(res?.body?.message);
      }
    } catch (error) {}
  }

  function getFilteredData(userSearch) {
    if (!userSearch) {
      setCases(casesData?.items || []);
      return;
    }

    const search = userSearch.toLowerCase();

    const searchableFields = [
      "nameOfPolicyholder",
      "caseId",
      "createdByName",
      "invoiceNoSmile",
      "customerNoSmile",
    ];

    const filtered = casesData?.items?.filter((item) =>
      searchableFields.some((field) =>
        item?.[field]?.toString()?.toLowerCase().includes(search),
      ),
    );

    setCases(filtered);
  }

  return (
    <div style={{ padding: "20px 24px" }}>
      <h2>{casesTableTrans.listOfCases}</h2>
      <div className={styles.messageSearch}>
        <div>
          <h3>Übersicht</h3>
          <p>
            Eine umfassende Übersicht über den Status und die Aktivitäten im
            System.
          </p>
        </div>
        <div>
          <Input
            placeholder={casesTableTrans.Search}
            onChange={(e) => setUserSearch(e.target.value)}
            prefix={<SearchOutlined />}
            style={{ height: "45px", width: "345px" }}
            maxLength={40}
          />
        </div>
      </div>
      <CasesTable
        isLoading={isLoading}
        cases={cases}
        employees={[]}
        heightOfTable={"80dvh"}
        variant="addNote"
        handleAddEmailToNote={handleAddEmailToNote}
        addEmailToNoteLoading={addEmailToNoteLoading}
        defaultPageSize={14}
      />
    </div>
  );
};
